import React from "react";
import { Box, FormControlLabel, Checkbox, FormLabel } from "@mui/material";
import { FieldArray } from "formik";

const CheckboxListForm = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  nameText,
  value,
  options,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        marginTop: "20px",
        width: "100%",
      }}
    >
      <FieldArray name={orderFormFieldKey}>
        {({ push, remove }) => {
          return (
            <Box display={"flex"} flexDirection={"column"}>
              <FormLabel id={`${orderFormFieldKey}-label`}>
                {nameText}
              </FormLabel>
              {(options || []).map(({ name, key }) => {
                const optionsKey = `${orderFormFieldKey}-${key || ""}`;
                return (
                  <FormControlLabel
                    key={optionsKey}
                    control={
                      <Checkbox
                        id={optionsKey}
                        name={optionsKey}
                        checked={(value || []).includes(key)}
                        onChange={(e) => {
                          e.target.checked ? push(key) : remove(key);
                        }}
                      />
                    }
                    label={name || ""}
                  />
                );
              })}
            </Box>
          );
        }}
      </FieldArray>
    </Box>
  );
};

export default CheckboxListForm;
